/**
 * ══════════════════════════════════════════════════════════════════════════
 * BRINDE ÓRFÃO — tira do carrinho a linha de brinde que o app esqueceu
 * ══════════════════════════════════════════════════════════════════════════
 *
 * O QUE ACONTECE SEM ISTO
 * Os brindes da loja vêm do app "EG Auto Add to Cart": o JS dele põe o produto
 * no carrinho com a propriedade `_Gifted`, e uma Function de desconto zera essa
 * linha. Os dois passos são independentes — e o primeiro erra a conta quando a
 * pessoa clica em "Comprar" mais de duas vezes na mesma página.
 *
 * Medido na loja ao vivo (Select One 300ml, 6 cliques de 1 unidade):
 *
 *     clique 1 → 1 comprado | 1 brinde grátis | 0 cobrado
 *     clique 2 → 2 comprado | 2 brindes grátis | 0 cobrado
 *     clique 3 → 3 comprado | 3 brindes grátis | 1 COBRADO   ← nasce a 2ª linha
 *     clique 4 → 4 comprado | 4 brindes grátis | 3 COBRADOS
 *     clique 5 → 5 comprado | 5 brindes grátis | 6 COBRADOS
 *     clique 6 → 6 comprado | 6 brindes grátis | 10 COBRADOS  ← R$ 199,00
 *
 * A partir do 3º `/cart/add.js` o app abre uma SEGUNDA linha do mesmo brinde e
 * despeja nela o excedente. A Function só zera a primeira; a segunda vai para o
 * checkout com preço cheio. O cliente paga por um brinde — e a conta cresce a
 * cada clique.
 *
 * Não é o desconto de kit: reproduzido em produto com UMA única regra de
 * brinde, e some quando a quantidade sobe pelo +/- da gaveta (`/cart/change.js`
 * nunca duplica). É bug do auto-add do app, não do tema.
 *
 * COMO O ÓRFÃO É RECONHECIDO
 * Amostrando o `/cart.js` a cada 300ms durante três adds, o app leva até ~3,5s
 * remexendo nas linhas, e no meio do caminho existe um estado em que um brinde
 * LEGÍTIMO aparece cobrado: o app põe o brinde no carrinho antes do produto que
 * o justifica chegar, e por ~1s a Function (corretamente) não cobre nada.
 *
 *     1268ms  brindes [{q:1, cobrado, sem desconto}]   ← legítimo, a caminho
 *     2289ms  brindes [{q:1, grátis}]
 *    32616ms  brindes [{q:2, cobrado, sem desconto}, {q:6, grátis}]  ← órfão
 *
 * O que separa um do outro é o GÊMEO: o órfão sempre convive com outra linha do
 * mesmo produto já zerada. O brinde a caminho está sozinho. Por isso a regra
 * exige as quatro coisas juntas:
 *
 *     tem `_Gifted`  +  preço > 0  +  nenhum desconto  +  existe gêmeo grátis
 *
 * Com o gêmeo como condição dá para agir em ~1,2s sem risco de apagar brinde
 * bom — sem ele, era preciso esperar o app assentar e o cliente via a cobrança.
 *
 * POR QUE A TELA TAMBÉM PRECISA SER REDESENHADA
 * `halo` vive dentro do IIFE de `theme.js` (`})(jQuery)` no fim do arquivo), ou
 * seja **`window.halo` é undefined**. Todo código do tema que faz
 * `if (typeof halo.updateSidebarCart === 'function')` nunca entra — inclusive o
 * do quiz e o do sofia-widget. Consertar só o carrinho no servidor deixava a
 * gaveta na tela com a linha cobrada e o total velho: era isso que aparecia nos
 * prints mesmo com a limpeza funcionando. Aqui a gaveta é recarregada na mão,
 * do mesmo jeito que o `theme.js` faz.
 *
 * Isto é remendo, não conserto: o certo é o app parar de duplicar. Enquanto
 * isso não vem, aqui o cliente não paga por brinde.
 */
(function () {
  'use strict';

  /* Propriedade que o EG App carimba na linha de brinde. Se o app mudar o
     nome, o órfão volta a passar — por isso a busca é por prefixo. */
  var MARCA_BRINDE = '_gifted';

  /* O app remexe nas linhas por até ~3,5s depois do add, e cada remexida pode
     criar um órfão novo. Uma passada só não basta; estas cobrem a janela
     inteira, e a primeira é cedo para o cliente não chegar a ver a cobrança. */
  var PASSADAS_MS = [1200, 3000, 5500, 9000];

  /* Teto de limpezas por página: se a limpeza e o app discordarem, é melhor
     parar e deixar o erro visível do que ficar girando contra o servidor. */
  var MAX_LIMPEZAS = 8;

  var limpezas = 0;
  var agendados = [];
  var ocupado = false;

  function ehLinhaDeBrinde(item) {
    var props = item && item.properties;
    if (!props) return false;
    for (var chave in props) {
      if (Object.prototype.hasOwnProperty.call(props, chave)) {
        if (String(chave).toLowerCase().indexOf(MARCA_BRINDE) === 0) return true;
      }
    }
    return false;
  }

  /**
   * @param {object} item  linha candidata
   * @param {object[]} itens  carrinho inteiro, para procurar o gêmeo
   */
  function ehOrfao(item, itens) {
    if (!ehLinhaDeBrinde(item)) return false;
    if (!(item.final_price > 0)) return false;

    /* Antes havia aqui um "tem desconto na linha? então não é sobra". Caiu em
       15/10/2026: o produto de brinde também tem faixas de kit, e desde que a
       Function passou a aplicar TODOS os candidatos (FIRST → ALL) a sobra
       passou a receber 7% — R$ 18,51 em vez de R$ 19,90. Com desconto na
       linha ela deixava de ser reconhecida e ia cobrada para o checkout.
       Brinde é grátis ou não é brinde: desconto parcial não absolve a linha.

       O gêmeo zerado é o que prova que a sobra é sobra, e não um brinde que
       ainda está a caminho de ser coberto. */
    for (var i = 0; i < itens.length; i++) {
      var outro = itens[i];
      if (outro.key === item.key) continue;
      if (outro.variant_id !== item.variant_id) continue;
      if (outro.final_price === 0) return true;
    }
    return false;
  }

  var fetchOriginal = window.fetch.bind(window);

  function pedir(url, corpo) {
    var opcoes = { headers: { Accept: 'application/json' } };
    if (corpo) {
      opcoes.method = 'POST';
      opcoes.headers['Content-Type'] = 'application/json';
      opcoes.body = JSON.stringify(corpo);
    }
    /* `fetchOriginal` escapa do nosso próprio gancho: sem isso cada remoção
       reagenda as passadas e o teto seria gasto à toa. */
    return fetchOriginal(url, opcoes).then(function (r) { return r.json(); });
  }

  /**
   * Redesenha a gaveta. Cópia do caminho do `theme.js`, porque o `halo` dele
   * não é alcançável de fora (ver o cabeçalho).
   *
   * Usa jQuery de propósito: cada linha do carrinho traz um `<script>` inline
   * com o estoque das variantes, e `innerHTML` não executa script — a gaveta
   * montada assim perde o +/-. O `.html()` do jQuery executa.
   */
  function redesenharGaveta() {
    var $ = window.jQuery;
    if (!$) return Promise.resolve();
    var $wrapper = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!$wrapper.length) return Promise.resolve();

    var raiz = (window.routes && window.routes.root) || '';
    return fetchOriginal(raiz + '/cart?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) { $wrapper.html($(html)); })
      .catch(function () {});
  }

  function sincronizarTela(cart) {
    try {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      if (window.cartStrings) {
        document.querySelectorAll('[data-cart-text]').forEach(function (el) {
          el.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
        });
      }
    } catch (e) {}

    return redesenharGaveta().then(function () {
      try {
        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (el) {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {}
    });
  }

  function limpar() {
    if (ocupado || limpezas >= MAX_LIMPEZAS) return;
    ocupado = true;

    pedir('/cart.js')
      .then(function (cart) {
        var itens = cart.items || [];
        var orfaos = itens.filter(function (i) { return ehOrfao(i, itens); });
        if (!orfaos.length) return null;

        /* Só a passada que mexe no carrinho conta para o teto: uma leitura que
           não achou nada não é risco de laço e não pode gastar crédito. */
        limpezas += 1;

        /* Uma remoção por vez: /cart/change.js em paralelo embaralha as linhas
           e devolve um carrinho que não corresponde a nenhum dos pedidos. */
        return orfaos.reduce(function (fila, item) {
          return fila.then(function () {
            return pedir('/cart/change.js', { id: item.key, quantity: 0 });
          });
        }, Promise.resolve()).then(function () {
          return pedir('/cart.js');
        });
      })
      .then(function (cart) {
        if (cart) return sincronizarTela(cart);
      })
      .catch(function () {})
      .then(function () { ocupado = false; });
  }

  function agendar() {
    agendados.forEach(clearTimeout);
    agendados = PASSADAS_MS.map(function (ms) { return setTimeout(limpar, ms); });
  }

  var ESCRITAS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function ehEscritaNoCarrinho(url) {
    if (!url) return false;
    var texto = String(url);
    for (var i = 0; i < ESCRITAS.length; i++) {
      if (texto.indexOf(ESCRITAS[i]) !== -1) return true;
    }
    return false;
  }

  /* ── ganchos ───────────────────────────────────────────────────────────── */

  window.fetch = function (recurso, opcoes) {
    var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url);
    var resposta = fetchOriginal(recurso, opcoes);
    if (ehEscritaNoCarrinho(url)) resposta.then(agendar, function () {});
    return resposta;
  };

  /* O app e o tema ainda usam XHR (o jQuery do Halo inclusive), então o gancho
     do fetch sozinho deixaria metade dos adds passar. */
  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (ehEscritaNoCarrinho(url)) {
      this.addEventListener('load', agendar);
    }
    return abrirOriginal.apply(this, arguments);
  };

  /* Carrinho que já chegou quebrado de outra sessão: a sobra fica salva no
     servidor e seguiria para o checkout sem ninguém mexer em nada. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else {
    agendar();
  }
})();
